import { flexRender, Row } from '@tanstack/react-table';
import type { ComparisonColumn } from './salesComparisonApi';
import type { ReportRow } from './salesComparisonTypes';
import { tdBase, ROW_BG, SIGN_COLOR, separatorBorder } from './salesComparisonStyles';

interface Props {
    row: Row<ReportRow>;
    columns: ComparisonColumn[];
}

// One table row: a full-width section header, or a data row (label + the store/total cells, styled by
// the cell's sign and the column's separator).
export function ComparisonBodyRow({ row, columns }: Props) {
    const original = row.original;

    if (original.kind === 'section') {
        return (
            <tr>
                <td colSpan={columns.length + 1} style={{ ...tdBase, background: '#f5f3ff', color: '#4c1d95', fontWeight: 700, textTransform: 'uppercase', fontSize: 11 }}>
                    {original.title}
                </td>
            </tr>
        );
    }

    const { style } = original;
    return (
        <tr style={{ background: ROW_BG[style], fontStyle: style === 'previous' || style === 'forecast' ? 'italic' : undefined, fontWeight: style === 'outcome' ? 700 : undefined }}>
            {row.getVisibleCells().map(cell => {
                const isLabel = cell.column.id === 'label';
                const value = isLabel ? undefined : original.cells[Number(cell.column.id.slice(1))];
                return (
                    <td key={cell.id} title={value?.title || undefined}
                        style={{
                            ...tdBase,
                            textAlign: isLabel ? 'left' : 'right',
                            position: isLabel ? 'sticky' : undefined,
                            left: isLabel ? 0 : undefined,
                            background: isLabel ? (ROW_BG[style] ?? '#fff') : undefined,
                            borderLeft: isLabel ? undefined : separatorBorder(columns[Number(cell.column.id.slice(1))]?.separator),
                            color: value?.sign ? SIGN_COLOR[value.sign] : undefined,
                            fontWeight: value?.sign && value.sign !== 'neu' ? 700 : undefined,
                        }}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                );
            })}
        </tr>
    );
}
